// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".brand-icon-image {\n  height: 40px;\n}\n\n.brand-icon-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin: 0px 8px 0px 24px;\n  border-radius: 4px;\n}\n", ""]);
// Exports
module.exports = exports;
